export const PROCESS_TYPE_SELECTED = 'taskTypeForm/PROCESS_TYPE_SELECTED';
export const ADD_BUTTON_CLICKED = 'taskTypeForm/ADD_BUTTON_CLICKED';
export const SUBMIT_TASKTYPE_FORM = 'taskTypeForm/SUBMIT_TASKTYPE_FORM';
